import classname from 'classnames'
import rem from '@/utils/rem'

const Input = ({ label, id, full, maxWidth, icon, ...inputProps }) => {

	const inputStyles = {
		maxWidth: rem(maxWidth)
	}

	const inputGroupClass = classname({
		'input-suffix-icon': true
	})

	return (
		<div className={inputGroupClass} style={inputStyles}>
			<div id={id} name={id}>
				<input type='text' {...inputProps} />
			</div>
			<div className='input-suffix-icon__icon'>{icon}</div>
		</div>
	)
}

export default Input
